export const OverviewPageId = 'OverviewPage';

export enum OverviewPageAttributes {
  ELEMENTS = 'overviewElements',
  HEADLINE = 'overviewHeadline',
  FILTERS = 'overviewTagFilters',
}
